import React from "react";

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
 variant?: "default" | "primary" | "success" | "warning" | "error";
 size?: "sm" | "md" | "lg";
}

const variantClasses = {
 default: "bg-gray-100 text-gray-800",
 primary: "bg-blue-100 text-blue-800",
 success: "bg-green-100 text-green-800",
 warning: "bg-yellow-100 text-yellow-800",
 error: "bg-red-100 text-red-800",
};

const sizeClasses = {
 sm: "px-2 py-0.5 text-xs",
 md: "px-2.5 py-1 text-sm",
 lg: "px-3 py-1.5 text-base",
};

export const Badge: React.FC<BadgeProps> = ({
 variant = "default",
 size = "md",
 className = "",
 children,
 ...props
}) => {
 return (
  <span
   className={`inline-flex items-center font-medium ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
   {...props}
  >
   {children}
  </span>
 );
};

export default Badge;

